<template>
    <div>
        <fieldset :disabled="formDisabled">
            <form class="form form-horizontal" v-on:submit.prevent >
                <div v-for="attachment in attachmentList" class="form-group" :key="attachment.index">
                    <label class="col-md-2 control-label">{{attachment.description}}</label>
                    <div class="col-md-4 form-inline" v-show="attachment.view === 'optional' || adminProdEdit || qaqcEnabled">
                        <select class="form-control" v-model="attachment.selectionId">
                            <option disabled value="">Select a value</option>
                            <option :value="1">Yes</option>
                            <option :value="2">No</option>
                        </select>
                    </div>
                    <div class="col-md-2" v-show="attachment.view != 'optional' && !adminProdEdit && !qaqcEnabled">
                        <label class="control-label"><span>{{attachment.view}}</span></label>
                    </div>
                    <label v-show="attachment.hasCount && (attachment.view !== 'not applicable' || adminProdEdit || qaqcEnabled)" class="col-md-2 control-label">Number of Attachments</label>
                    <div v-show="attachment.hasCount  && (attachment.view !== 'not applicable' || adminProdEdit || qaqcEnabled)" class="col-md-1">
                        <input type="number" min="0" class="form-control" v-model="attachment.count">
                    </div>
                </div>
                <div v-if="!(formDisabled)" class="form-group">
                    <div class="col-md-2">
                        <button class="btn btn-primary pull-right" v-on:click="saveAttachmentSelection">Save</button>
                    </div>
                </div>
            </form>
        </fieldset>
        <div class="panel panel-offset" id="attachments">
            <div class="panel-heading" v-bind:class="qaqcEnabled ? 'qaqc-bg' : 'green-bg'">
                <h3 class="panel-title">Attachments</h3>
            </div>
            <div v-if="attachmentSelection" class="panel-body">
                <tabs>
                    <tab v-if="attachmentSelection.hasPrehistoricArtifact" header="Prehistoric Artifacts">
                        <prehistoricArtifactForm :formDisabled="formDisabled" :qaqcEnabled="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto"
                        :saveQaqcProgress="saveQaqcProgress" :crrId="crrId"></prehistoricArtifactForm>
                    </tab>
                    <tab v-if="attachmentSelection.hasPrehistoricFeature" header="Prehistoric Features">
                        <prehistoricFeatureForm :formDisabled="formDisabled" :qaqcEnabled="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto"
                        :saveQaqcProgress="saveQaqcProgress" :crrId="crrId"></prehistoricFeatureForm>
                    </tab>
                    <tab v-if="attachmentSelection.hasHistoricArtifact" header="Historic Artifacts">
                        <historicArtifactForm :formDisabled="formDisabled" :qaqcEnabled="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto"
                        :saveQaqcProgress="saveQaqcProgress" :crrId="crrId"></historicArtifactForm>
                    </tab>
                    <tab v-if="attachmentSelection.hasHistoricFeature" header="Historic Features">
                        <historicFeatureForm :formDisabled="formDisabled" :qaqcEnabled="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto"
                        :saveQaqcProgress="saveQaqcProgress" :crrId="crrId"></historicFeatureForm>
                    </tab>
                    <tab v-if="attachmentSelection.hasRockArt && attachmentSelection.rockArtCount > 0" header="Rock Art">
                        <rockArtForm :rockArtCount="attachmentSelection.rockArtCount" :formDisabled="formDisabled" :qaqcEnabled="qaqcEnabled" :productionCrrId="productionCrrId"
                        :qaqcProgressDto="qaqcProgressDto" :saveQaqcProgress="saveQaqcProgress" :crrId="crrId"></rockArtForm>
                    </tab>
                    <tab v-if="attachmentSelection.hasHistoricBuilding && attachmentSelection.historicBuildingCount > 0" header="Historic Building">
                        <historicBuildingForm :attachmentCount="attachmentSelection.historicBuildingCount" :formDisabled="formDisabled" :qaqcEnabled="qaqcEnabled"
                        :productionCrrId="productionCrrId" :qaqcProgressDto="qaqcProgressDto" :saveQaqcProgress="saveQaqcProgress" :crrId="crrId" :isSegment="!!culturalResource.segment"
                        :projectId="projectId"></historicBuildingForm>
                    </tab>
                    <tab v-if="attachmentSelection.hasLinearResource" header="Linear Resource">
                        <linearResourceForm :formDisabled="formDisabled" :qaqcEnabled="qaqcEnabled"
                        :qaqcProgressDto="qaqcProgressDto" :saveQaqcProgress="saveQaqcProgress" :crrId="crrId"></linearResourceForm>
                    </tab>
                    <tab v-if="attachmentSelection.hasStructureObject && attachmentSelection.structureObjectCount > 0" header="Structure/Object">
                        <structureObjectForm :attachmentCount="attachmentSelection.structureObjectCount" :formDisabled="formDisabled" :qaqcEnabled="qaqcEnabled" :productionCrrId="productionCrrId"
                        :qaqcProgressDto="qaqcProgressDto" :saveQaqcProgress="saveQaqcProgress" :crrId="crrId"></structureObjectForm>
                    </tab>
                    <tab v-if="attachmentSelection.hasUnknownFeature" header="Unknown Features">
                        <unknownFeatureForm :formDisabled="formDisabled" :qaqcEnabled="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto"
                        :saveQaqcProgress="saveQaqcProgress" :crrId="crrId"></unknownFeatureForm>
                    </tab>
                </tabs>
            </div>
        </div>
    </div>
</template>

<script>
import culturalResourceRecordingService from '../../services/culturalResourceRecordingService'
import culturalResourceService from '../../services/culturalResourceService'
import loggingService from '../../services/util/loggingService'

import prehistoricArtifactForm from './PrehistoricArtifactForm.vue'
import prehistoricFeatureForm from './PrehistoricFeatureForm.vue'
import historicArtifactForm from './HistoricArtifactForm.vue'
import historicFeatureForm from './HistoricFeatureForm.vue'
import rockArtForm from './RockArtForm.vue'
import linearResourceForm from './LinearResourceForm.vue'
import historicBuildingForm from './HistoricBuildingForm.vue'
import structureObjectForm from './HistoricStructureObjectForm.vue'
import unknownFeatureForm from './UnknownFeatureForm.vue'
import { tab, tabs } from 'vue-strap'

export default {
    name: 'attachments',
    components: {
        prehistoricArtifactForm,
        prehistoricFeatureForm,
        historicArtifactForm,
        historicFeatureForm,
        rockArtForm,
        linearResourceForm,
        historicBuildingForm,
        structureObjectForm,
        unknownFeatureForm,
        tab,
        tabs
    },
    computed: {
        showAttachmentCount: function () {
            var attachments = []
            this.attachmentList.forEach(attachment => {
                if (attachment.view === 'required' || attachment.selectionId === '1') {
                    attachments.push(attachment.description)
                }
            })
            var list = attachments.join(', ')
            return list
        },
        showAttachmentCount2: function (attachment) {
            this.log(`Determining show count for ${attachment.description}`)
            if (attachment.view === 'not applicable') {
                this.log('     no, because not applicable')
                return false
            } else if (attachment.hasCount) {
                this.log(`     if selectionId (${attachment.selectionId}) is 1: ${attachment.selectionId === '1'}`)
                return (attachment.selectionId === '1')
            } else {
                this.log('     default no')
                return false
            }
        },
        districtOwnershipTypes: function () {
            return culturalResourceService.DistrictOwnershipTypeEnum
        }
    },
    props: {
        formDisabled: { default: false },
        qaqcEnabled: { default: false },
        productionCrrId: { default: null },
        qaqcProgressDto: { default: () => {} },
        saveQaqcProgress: { default: null },
        crrId: { default: null },
        loadOnMount: { default: true },
        projectId: { default: null },
        adminProdEdit: { default: false }
    },
    data: function () {
        return {
            isDebug: false,
            culturalResource: {},
            attachmentList: [],
            propertyFlags: {},
            timePeriodsFlags: {},
            rockArtCount: 0,
            selectionsMade: false,
            attachmentSelection: {}
            //segmentList: []
        }
    },
    watch: {
        // crrId: function (val) {
        //     this.log('crrId is changed: ' + val)
        //     this.loadData()
        // }
    },
    mounted () {
        if (this.loadOnMount && this.crrId) {
            this.loadData()
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Attachment Selection', message)
        },
        saveAttachmentSelection (loadData = true) {
            var attachmentSelectionDto = {}
            if (this.selectionsMade) {
                attachmentSelectionDto = this.attachmentSelection
            }
            attachmentSelectionDto.culturalResourceRecordingId = this.crrId

            attachmentSelectionDto.hasPrehistoricArtifact = this.isSelected('Prehistoric Artifacts')
            attachmentSelectionDto.hasPrehistoricFeature = this.isSelected('Prehistoric Features')
            attachmentSelectionDto.hasHistoricArtifact = this.isSelected('Historic Artifacts')
            attachmentSelectionDto.hasHistoricFeature = this.isSelected('Historic Features')
            attachmentSelectionDto.hasRockArt = this.isSelected('Rock Art')
            attachmentSelectionDto.rockArtCount = this.attachmentList.find(x => { return x.description === 'Rock Art' }).count
            attachmentSelectionDto.hasHistoricBuilding = this.isSelected('Historic Building')
            attachmentSelectionDto.historicBuildingCount = this.attachmentList.find(x => { return x.description === 'Historic Building' }).count
            attachmentSelectionDto.hasLinearResource = this.isSelected('Linear Resource')
            attachmentSelectionDto.hasStructureObject = this.isSelected('Structure/Object')
            attachmentSelectionDto.structureObjectCount = this.attachmentList.find(x => { return x.description === 'Structure/Object' }).count
            attachmentSelectionDto.hasUnknownFeature = this.isSelected('Unknown Features')
            this.log(`building? ${attachmentSelectionDto.hasHistoricBuilding}`)

            culturalResourceRecordingService.putAttachmentSelection(this.$http, attachmentSelectionDto).then(result => {
                if (loadData) this.loadData(false)
            })
        },
        loadCulturalResource (culturalResourceId) {
            this.log('loading CR')
            return culturalResourceService.get(this.$http, culturalResourceId).then(response => {
                this.culturalResource = response.data
                var secondarySiteTypes = this.culturalResourceRecording.secondarySiteTypeList.map(x => {
                    return x.siteTypeId
                })
                var secondaryTimePeriods = this.culturalResourceRecording.secondaryTimePeriodList.map(x => {
                    return x.timePeriodId
                })
                this.culturalResource.propertyTypes = [this.culturalResourceRecording.siteTypeId].concat(secondarySiteTypes)
                this.culturalResource.timePeriods = [this.culturalResourceRecording.timePeriodId].concat(secondaryTimePeriods)
                this.log('CR loaded')
                this.log(`type: ${this.culturalResource.siteTypeId}`)
                this.log(`period: ${this.culturalResource.timePeriodId}`)
                return response
            })
        },
        loadData (saveAfterLoad = true) {
            var crrId = this.crrId
            this.log('loading data for ' + crrId)
            if (crrId) {
                culturalResourceRecordingService.get(this.$http, crrId).then(response => {
                    this.culturalResourceRecording = response.data
                    this.selectionsMade = this.culturalResourceRecording.attachmentSelection !== null
                    this.attachmentSelection = this.culturalResourceRecording.attachmentSelection
                    this.log('CRR returned, attachments? ' + this.selectionsMade)
                    this.log('CRR returned, attachments:' + this.culturalResourceRecording.attachmentSelection)
                    this.loadCulturalResource(this.culturalResourceRecording.culturalResourceId).then(response2 => {
                        this.log('CR Loaded')
                        // if this is a district, find the segment list, then build flags
                        // if (this.culturalResource.siteTypeId === culturalResourceRecordingService.PropertyTypeEnum.District) {
                        //     culturalResourceService.getSegments(this.$http, this.culturalResource.culturalResourceId).then(result => {
                        //         this.// = result.data
                        //         this.buildFlags()
                        //         this.buildFlags2()
                        //     })
                        // } else {
                        //     this.buildFlags()
                        //     this.buildFlags2()
                        // }
                        // return response2
                        this.buildFlags()
                        this.buildFlags2()
                        this.$emit('update:attachments', this.showAttachmentCount)
                        //save attachement after building flags (in case attachment requirements changed)
                        if (!this.formDisabled && this.selectionsMade && saveAfterLoad) this.saveAttachmentSelection(false)
                    })
                })
            }
        },
        isSelected (description) {
            this.log('looking at isSelected for ' + description)
            var attachment = this.attachmentList.find(x => { return x.description === description })
            this.log(`Found ${attachment.description} with selectionId = ${attachment.selectionId}, view: ${attachment.view} `)
            return attachment.view === 'required' || attachment.selectionId.toString() === '1'
        },
        buildFlags () {
            this.log('building flags')
            var x = 1
            var val = ''
            for (var tabName in this.attachmentTabs) {
                this.attachmentOptions[tabName] = x
                x = x << 1
            }
            for (var propEnum in culturalResourceRecordingService.PropertyTypeEnum) {
                val = culturalResourceRecordingService.PropertyTypeEnum[propEnum]
                if (~(this.culturalResource.propertyTypes.indexOf(val))) {
                    this.log('found prop type ' + propEnum)
                    this.propertyFlags[propEnum] = 1
                }
            }
            for (var timeEnum in culturalResourceRecordingService.TimePeriodEnum) {
                val = culturalResourceRecordingService.TimePeriodEnum[timeEnum]
                if (~(this.culturalResource.timePeriods.indexOf(val))) {
                    this.log('found time period ' + timeEnum)
                    this.timePeriodsFlags[timeEnum] = 1
                }
            }
        },
        getSelectionId (isSet) {
            return (isSet) ? '1' : '2'
        },
        buildFlags2 () {
            this.log('Build Flags 2')
            var indices = {
                prehistoricArtifact: 0,
                prehistoricFeature: 1,
                historicArtifact: 2,
                historicFeature: 3,
                rockArt: 4,
                historicBuilding: 5,
                linearResource: 6,
                structureObject: 7,
                unknownFeature: 8
            }
            this.attachmentList = [
                {id: 0, description: 'Prehistoric Artifacts', view: 'not applicable'},
                {id: 1, description: 'Prehistoric Features', view: 'not applicable'},
                {id: 2, description: 'Historic Artifacts', view: 'not applicable'},
                {id: 3, description: 'Historic Features', view: 'not applicable'},
                {id: 4, description: 'Rock Art', view: 'not applicable', hasCount: true, count: 0},
                {id: 5, description: 'Historic Building', view: 'not applicable', hasCount: true, count: 0},
                {id: 6, description: 'Linear Resource', view: 'not applicable'},
                {id: 7, description: 'Structure/Object', view: 'not applicable', hasCount: true, count: 0},
                {id: 8, description: 'Unknown Features', view: 'not applicable'}
            ]

            if (this.propertyFlags.Site && this.timePeriodsFlags.Prehistoric) {
                this.log('build-flags2 - site & prehistoric')
                this.attachmentList.forEach(attachment => {
                    if ([indices.prehistoricArtifact, indices.prehistoricFeature, indices.rockArt].includes(attachment.id)) {
                        attachment.view = 'optional'
                    }
                })
            }
            if (this.propertyFlags.Site && this.timePeriodsFlags.Historic) {
                this.log('build-flags2 - site & historic')
                this.attachmentList.forEach(attachment => {
                    if ([indices.historicArtifact, indices.historicFeature, indices.rockArt].includes(attachment.id)) {
                        attachment.view = 'optional'
                    }
                })
            }
            if (this.propertyFlags.Building) {
                this.log('build-flags2 - building')
                this.attachmentList.forEach(attachment => {
                    if (attachment.id === indices.historicBuilding) {
                        attachment.view = 'required'
                    }
                })
            }
            if (this.propertyFlags.Structure) {
                this.log('build-flags2 - structure')
                this.attachmentList.forEach(attachment => {
                    if (attachment.id === indices.structureObject) {
                        attachment.view = 'required'
                    }
                })
            }
            if (this.propertyFlags.Object) {
                this.log('build-flags2 - object')
                this.attachmentList.forEach(attachment => {
                    if (attachment.id === indices.structureObject) {
                        attachment.view = 'required'
                    } else if (attachment.id === indices.rockArt) {
                        attachment.view = 'optional'
                    }
                })
            }
            if (this.propertyFlags.District || this.propertyFlags.Landscape) {
                this.log('build-flags2 - district, landscape')
                this.attachmentList.forEach(attachment => {
                    if ([indices.rockArt, indices.linearResource].includes(attachment.id)) {
                        attachment.view = 'optional'
                    }
                })
            }
            //unknown Site (unknown time period)
            if (this.timePeriodsFlags.Unknown) {
                this.log('build-flags2 - unknown time period type')
                this.attachmentList.forEach(attachment => {
                    if ([indices.unknownFeature].includes(attachment.id)) {
                        attachment.view = 'optional'
                    }
                })
            }
            //build attachment flags for District and Linear Resources
            // if (this.propertyFlags.District) {
            //     this.log('build-flags2 - district')
            //     var linearTypes = [this.districtOwnershipTypes.LinearMultiCounty, this.districtOwnershipTypes.LinearSingleCounty]
            //     //for districts
            //     if (!linearTypes.includes(this.culturalResource.districtOwnershipTypeId)) {
            //         this.attachmentList.forEach(attachment => {
            //             if ([indices.historicBuilding].includes(attachment.id)) {
            //                 attachment.view = 'optional'
            //             }
            //             if ([indices.linearResource].includes(attachment.id)) {
            //                 attachment.view = 'not applicable'
            //             }
            //         })
            //     }
            // }
            if (this.attachmentSelection) {
                this.log('setting selectionIds to persisted values:' + this.culturalResourceRecording.attachmentSelection)
                this.log('attachmentSelection count:' + this.attachmentList.length)
                var attachmentDto = this.culturalResourceRecording.attachmentSelection

                this.attachmentList[indices.prehistoricArtifact].selectionId = this.getSelectionId(attachmentDto.hasPrehistoricArtifact)
                this.attachmentList[indices.prehistoricFeature].selectionId = this.getSelectionId(attachmentDto.hasPrehistoricFeature)
                this.attachmentList[indices.historicArtifact].selectionId = this.getSelectionId(attachmentDto.hasHistoricArtifact)
                this.attachmentList[indices.historicFeature].selectionId = this.getSelectionId(attachmentDto.hasHistoricFeature)
                this.attachmentList[indices.rockArt].selectionId = this.getSelectionId(attachmentDto.hasRockArt)
                this.attachmentList[indices.rockArt].count = attachmentDto.rockArtCount
                this.attachmentList[indices.historicBuilding].selectionId = this.getSelectionId(attachmentDto.hasHistoricBuilding)
                this.attachmentList[indices.historicBuilding].count = attachmentDto.historicBuildingCount
                this.attachmentList[indices.linearResource].selectionId = this.getSelectionId(attachmentDto.hasLinearResource)
                this.attachmentList[indices.structureObject].selectionId = this.getSelectionId(attachmentDto.hasStructureObject)
                this.attachmentList[indices.structureObject].count = attachmentDto.structureObjectCount
                this.attachmentList[indices.unknownFeature].selectionId = this.getSelectionId(attachmentDto.hasUnknownFeature)
                this.log('attachmentSelection count, after:' + this.attachmentList.length)

                //reset selections to no if they're not applicable
                if (!this.qaqcEnabled) {
                    this.attachmentList.forEach(attachment => {
                        if (attachment.view === 'not applicable') {
                            attachment.selectionId = 2
                        }
                    })
                }
            } else {
                this.log('setting selectionIds to default')
                this.attachmentList.forEach(attachment => {
                    if (attachment.view === 'optional') {
                        attachment.selectionId = ''
                    } else if (attachment.view === 'required') {
                        attachment.selectionId = 1
                    } else {
                        attachment.selectionId = 2
                    }
                    // if (this.propertyFlags.District && [indices.historicBuilding].includes(attachment.id)) {
                    //     //if selections haven't been made, set default historic building selections
                    //     attachment.selectionId = 1
                    //     attachment.count = this.//.length
                    // }
                })
            }
            this.log('done building attachmentList')
            this.attachmentList.forEach(attachment => {
                this.log('attachment: ' + attachment.description)
                attachment.showCount = function (attachment) {
                    if (attachment.view === 'not applicable') {
                        return false
                    } else if (this.hasCount) {
                        return (attachment.selectionId === '1')
                    } else {
                        return false
                    }
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// Attachments.vue?1f194927